import { VStack, Text } from "@bpba/ui-components";
import { InfoItem } from "./InfoItem";
 
type InfoProps = {
  info?: string;
  infoList?: [string, string[]][];
};
 
export const Info = (props: InfoProps) => {
  if (!props) return <></>;
 
  return (
    <VStack>
      <Text textAlign={"justify"}
            children={props.info} tabIndex={0}/>
      {props.infoList?.map((infoItem, index) => {
        return (
          <InfoItem
            key={index}
            index={index + 1}
            titulo={infoItem[0]}
            info={infoItem[1]}
          />
        );
      })}
     
    </VStack>
  );
};